import React, { Component } from 'react'
import actions from 'redux/actions'
import PropTypes from 'prop-types'
import { constants } from 'common/helpers'
import { FormattedHTMLMessage } from 'sb-react-intl'

import Box from 'components/_new/layout/Box/Box'
import CommonButton from 'components/buttons/CommonButton/CommonButton'
import Modal from 'components/modal/Modal/Modal'

import messages from './messages'


class ProlongThankYouModal extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
  }

  static defaultProps = {
    name: constants.modals.cancelSubscription.ProlongThankYou,
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  render() {
    const { name, data } = this.props

    return (
      <Modal
        name={name}
        title={messages.title}
      >
        <FormattedHTMLMessage tag="div" {...messages.text} values={data} />
        <Box alignCenter mt="20">
          <CommonButton gray close onClick={this.close} />
        </Box>
      </Modal>
    )
  }
}


export default ProlongThankYouModal
